/**
 * DOM builders for layout: "useCases" scroll story panels.
 * Extracted for unit testing without mounting HeroApp / Three.js.
 */

const SCENARIO_FIELDS = [
  "category",
  "headline",
  "problem",
  "solution",
  "outcome",
  "serviceLabel",
  "servicePath",
];

function appendLabeledParagraph(parent, label, text) {
  if (text == null || String(text).trim() === "") return;
  const row = document.createElement("div");
  row.className = "story-use-case-row";

  const dt = document.createElement("span");
  dt.className = "story-use-case-row__label";
  dt.textContent = label;

  const dd = document.createElement("p");
  dd.className = "story-use-case-row__text";
  dd.textContent = String(text);

  row.append(dt, dd);
  parent.appendChild(row);
}

/**
 * @param {Record<string, unknown>} scenario
 * @returns {HTMLElement}
 */
export function buildUseCaseCard(scenario = {}) {
  const card = document.createElement("article");
  card.className = "story-use-case-card";
  if (scenario.featured) {
    card.classList.add("story-use-case-card--featured");
  }

  if (scenario.category) {
    const category = document.createElement("p");
    category.className = "story-use-case-category";
    category.textContent = String(scenario.category);
    card.appendChild(category);
  }

  if (scenario.headline) {
    const headline = document.createElement("h3");
    headline.className = "story-use-case-headline";
    headline.textContent = String(scenario.headline);
    card.appendChild(headline);
  }

  appendLabeledParagraph(card, "Problem", scenario.problem);
  appendLabeledParagraph(card, "Configured", scenario.solution);
  appendLabeledParagraph(card, "Outcome", scenario.outcome);

  const servicePath =
    scenario.servicePath != null ? String(scenario.servicePath).trim() : "";
  const serviceLabel =
    scenario.serviceLabel != null ? String(scenario.serviceLabel).trim() : "";

  if (servicePath && servicePath.startsWith("/") && serviceLabel) {
    const serviceLink = document.createElement("a");
    serviceLink.className = "story-use-case-service";
    serviceLink.href = servicePath;
    serviceLink.textContent = serviceLabel;
    serviceLink.setAttribute(
      "aria-label",
      `${serviceLabel} - view service details`,
    );
    card.appendChild(serviceLink);
  }

  return card;
}

/**
 * @param {HTMLElement} panel
 * @param {Record<string, unknown>} section
 */
export function appendUseCaseContent(panel, section = {}) {
  const scenarios = Array.isArray(section.scenarios) ? section.scenarios : [];

  if (scenarios.length > 0) {
    const grid = document.createElement("div");
    grid.className = "story-use-cases-grid";

    for (const scenario of scenarios) {
      if (!scenario || typeof scenario !== "object") continue;
      grid.appendChild(buildUseCaseCard(scenario));
    }

    if (grid.childElementCount > 0) {
      panel.appendChild(grid);
    }
  }

  const universal = section.universal;
  if (universal && typeof universal === "object") {
    const footer = document.createElement("div");
    footer.className = "story-use-case-universal";

    if (universal.title) {
      const title = document.createElement("h3");
      title.className = "story-use-case-universal__title";
      title.textContent = String(universal.title);
      footer.appendChild(title);
    }

    if (universal.body) {
      const body = document.createElement("p");
      body.className = "story-use-case-universal__body";
      body.textContent = String(universal.body);
      footer.appendChild(body);
    }

    if (footer.childElementCount > 0) {
      panel.appendChild(footer);
    }
  }
}

export { SCENARIO_FIELDS };
